var map = {
	"./classic/metadata.json": 77027,
	"./csp/metadata.json": 61453,
	"./federal/metadata.json": 13852,
	"./harvester/metadata.json": 94649,
	"./rgs/metadata.json": 38123,
	"./suse/metadata.json": 36045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91236;